import DOMPurify from 'dompurify';
import React from 'react';
import {Body, designSystemToken, Icon} from '@lightricks/react-design-system';
import styles from './BriefHtml.module.scss';

// DOMPurify hooks are global to the module instance, so this must stay the app's
// single registration site. Replaces Ember's `contentHtml.replace(/<a/gi, …)`.
DOMPurify.addHook('afterSanitizeAttributes', (node: Element) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

export function sanitizeBriefHtml(html: string): string {
  return DOMPurify.sanitize(html);
}

interface BriefHtmlProps {
  contentHtml?: string | null;
  /** Rendered as text, not HTML — deliberately stricter than Ember's html-safe. */
  highlighted?: string | null;
  testID?: string;
}

function BriefHtml({
  contentHtml,
  highlighted,
  testID = 'brief-html',
}: BriefHtmlProps) {
  if (!contentHtml && !highlighted) {
    return null;
  }

  return (
    <div data-testid={testID}>
      {contentHtml ? (
        <div
          className={styles.content}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{__html: sanitizeBriefHtml(contentHtml)}}
        />
      ) : null}
      {highlighted ? (
        <div
          className={styles.highlighted}
          data-testid={`${testID}-highlighted`}
        >
          <Icon
            size="medium"
            appearance="neutral"
            name="Actions-Alert-Line"
            color={designSystemToken('semantic.fg.warning')}
          />
          <Body size="md">{highlighted}</Body>
        </div>
      ) : null}
    </div>
  );
}

export default BriefHtml;
